import Headroom from 'headroom.js';
import {find, fire, on, addClass, removeClass, hasClass} from '../helpers';
import '../../../css/components/_sticky-nav.pcss';

const header = find('[data-header]');

on('trigger-solid', () => {
    if (hasClass(header, 'is-transparent')) {
        addClass(header, 'default-nav');
    }
});

on('trigger-transparent', () => {
    if (hasClass(header, 'is-transparent')) {
        removeClass(header, 'default-nav');
    }
});

new Headroom(header, {
    offset: header.clientHeight,
    onUnpin: () => {
        fire('dropdown-close');
        fire('trigger-solid');
    },
    onTop: () => fire('trigger-transparent'),
    onNotTop: () => {
        fire('trigger-solid');
    },
}).init();
